import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AuthContext } from "../../contexts/AuthContext";
import { getGroupEmail } from "../../helpers/authUser";
import theme from "../../theme";

const useStyles = makeStyles((theme) => ({
    subText: {
        fontFamily: 'Inter',
        fontSize: '0.95rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    link: {
        display: '-webkit-box',
        textDecoration: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        wordBreak: 'break-all',
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
}));

const ForwardDeals: React.FC<{ label?: string, color?: string }> = ({ label, color }) => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { userGroup } = useContext(AuthContext);

    return (<>
        <Stack alignItems="flex-start" justifyContent="flex-start" width="100%" pl={1}>
            <Typography className={classes.subText}>
                {label || 'Forward companies to: '}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <Typography className={classes.link} color={color || theme.palette.primary.main}
                    onClick={() => window.open(`mailto: ${getGroupEmail(userGroup)}`, '_self', 'noopener, noreferrer')}>
                    {getGroupEmail(userGroup)}
                </Typography>
                <CopyToClipboard text={`${getGroupEmail(userGroup)}`}
                    options={{ format: "text/plain" }}
                    onCopy={() => {
                        enqueueSnackbar(`Successfully copied to clipboard.`,
                            { anchorOrigin: { vertical: "bottom", horizontal: "right" }, });
                    }}>
                    <IconButton size="small" sx={{ color: theme.colors.cyan['500'] }}>
                        <ContentCopyIcon sx={{ width: 24, height: 24, }} />
                    </IconButton>
                </CopyToClipboard>
            </Stack>
        </Stack>
    </>);
}

export default ForwardDeals;
